// JS30 Challenges Data
// This file contains all JS30 challenge information
// To add a new challenge, simply add a new object to the array

export const js30Challenges = [
  {
    key: "js1",
    githubLink: "https://github.com/Netsujr/JS1-DrumKit",
    websiteLink: "https://netsujr.github.io/JS1-DrumKit/",
  },
  {
    key: "js2",
    githubLink: "https://github.com/Netsujr/JS2-Clock",
    websiteLink: "https://netsujr.github.io/JS2-Clock/",
  },
  {
    key: "js3",
    githubLink: "https://github.com/Netsujr/JS3-CSS_Variables",
    websiteLink: "https://netsujr.github.io/JS3-CSS_Variables/",
  },
  {
    key: "js5",
    githubLink: "https://github.com/Netsujr/JS5-Flex_Panel_Gallery",
    websiteLink: "https://netsujr.github.io/JS5-Flex_Panel_Gallery/",
  },
  {
    key: "js6",
    githubLink: "https://github.com/Netsujr/JS6-Type_Ahead",
    websiteLink: "https://netsujr.github.io/JS6-Type_Ahead/",
  },
  {
    key: "js8",
    githubLink: "https://github.com/Netsujr/JS8-HTML_Canvas",
    websiteLink: "https://netsujr.github.io/JS8-HTML_Canvas/",
  },
  {
    key: "js10",
    githubLink: "https://github.com/Netsujr/JS10-Checkboxes",
    websiteLink: "https://netsujr.github.io/JS10-Checkboxes/",
  },
  {
    key: "js11",
    githubLink: "https://github.com/Netsujr/JS11-Video_player",
    websiteLink: "https://netsujr.github.io/JS11-Video_player/",
  },
  {
    key: "js15",
    githubLink: "https://github.com/Netsujr/JS15-LocalStorage",
    websiteLink: "https://netsujr.github.io/JS15-LocalStorage/",
  },
  {
    key: "js16",
    githubLink: "https://github.com/Netsujr/JS16-mouse_move_effect",
    websiteLink: "https://netsujr.github.io/JS16-mouse_move_effect/",
  },
  {
    key: "js17",
    githubLink: "https://github.com/Netsujr/JS17-Sorting_band_names",
    websiteLink: "https://netsujr.github.io/JS17-Sorting_band_names/",
  },
  {
    key: "js18",
    githubLink: "https://github.com/Netsujr/JS18-stringNames_reduce",
    websiteLink: "https://netsujr.github.io/JS18-stringNames_reduce/",
  },
  {
    key: "js20",
    githubLink: "https://github.com/Netsujr/JS20-Speech_Detection",
    websiteLink: "https://netsujr.github.io/JS20-Speech_Detection/",
  },
  {
    key: "js23",
    githubLink: "https://github.com/Netsujr/JS23-Speech_synthesis",
    websiteLink: "https://netsujr.github.io/JS23-Speech_synthesis/",
  },
  {
    key: "js24",
    githubLink: "https://github.com/Netsujr/JS24-Sticky_Nav",
    websiteLink: "https://netsujr.github.io/JS24-Sticky_Nav/",
  },
  {
    key: "js26",
    githubLink: "https://github.com/Netsujr/JS26-Stripe_follow_Nav",
    websiteLink: "https://netsujr.github.io/JS26-Stripe_follow_Nav/",
  },
  {
    key: "js27",
    githubLink: "https://github.com/Netsujr/JS27-Click_and_Drag",
    websiteLink: "https://netsujr.github.io/JS27-Click_and_Drag/",
  },
  {
    key: "js28",
    githubLink: "https://github.com/Netsujr/JS28-Video_speed_controller",
    websiteLink: "https://netsujr.github.io/JS28-Video_speed_controller/",
  },
  {
    key: "js29",
    githubLink: "https://github.com/Netsujr/JS29-Countdown_Clock",
    websiteLink: "https://netsujr.github.io/JS29-Countdown_Clock/",
  },
  {
    key: "js30",
    githubLink: "https://github.com/Netsujr/JS30-Wack_a_mole",
    websiteLink: "https://netsujr.github.io/JS30-Wack_a_mole/",
  },
];
